import {
  forwardRef,
  HTMLAttributes,
  ReactElement,
  CSSProperties,
  useEffect,
  useState,
} from 'react';
import { Typography } from '../Typography/Typography';

import Briefcase from '@/assets/icons/briefcase.svg?react';
import Retail from '@/assets/icons/retail.svg?react';
import StandaloneBuilding from '@/assets/icons/standaloneBuilding.svg?react';
import LinkIcon from '@/assets/icons/linkArrow.svg?react';

import { cn } from '@/shared/lib/utils';
import { directionType } from '@/entities/home_content/model/types';
import { Button } from '../Button';

export interface KnowledgeCategoryCardProps
  extends HTMLAttributes<HTMLDivElement> {
  category: directionType;
}

const iconMap: Record<'commercial' | 'retail' | 'residential', ReactElement> = {
  commercial: <Briefcase className="h-18px w-[18px]" />,
  retail: <Retail className="h-18px w-[18px]" />,
  residential: <StandaloneBuilding className="h-18px w-[18px]" />,
};

const bgMap: Record<'commercial' | 'retail' | 'residential', string> = {
  commercial: '/images/type_of_buildings/business.png',
  retail: '/images/type_of_buildings/retail.png',
  residential: '/images/type_of_buildings/standalone.png',
};

export const KnowledgeCategoryCard = forwardRef<
  HTMLDivElement,
  KnowledgeCategoryCardProps & { handleNavigate: (id: string) => void }
>(({ className, category, handleNavigate, ...props }, ref) => {
  const categoryIcon = iconMap[category.id] || <Briefcase />;
  return (
    <div
      style={{
        backgroundImage: `url(${category.imageUrl ? category.imageUrl : bgMap[category.id]})`,
      }}
      className={cn(
        'bg-no-repeat, h-[200px] overflow-hidden rounded-[30px] bg-cover bg-center xl:h-[450px] xl:w-1/3',
        className
      )}
    >
      <div className="flex h-full w-full flex-col justify-end gap-[12px] bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.7)_100%)] p-[12px] md:gap-[20px] xl:p-[24px]">
        <div className="flex items-center gap-[12px] md:gap-[20px]">
          <div className="flex min-h-[36px] min-w-[36px] items-center justify-center rounded-full bg-white">
            {iconMap[category.id]}
          </div>
          <Typography className="text-[16px] text-white md:text-[18px]">
            {category.description}
          </Typography>
        </div>
        <Button
          endIcon={
            <LinkIcon className="shadow-cls h-[30px] w-[30px] rounded-full" />
          }
          text={category.title}
          className="h-[38px] w-full bg-white p-[4px] pl-[16px] text-[14px] uppercase md:h-[54px] md:p-[12px] md:pl-[16px] md:text-[16px]"
          onClick={() => handleNavigate(category.id)}
        />
      </div>
    </div>
  );
});

KnowledgeCategoryCard.displayName = 'KnowledgeCategoryCard';
